export interface SecurityAsset {
  id: string;
  name: string;
  type: 'APPLICATION' | 'DATABASE' | 'API' | 'CONTAINER' | 'SECRET';
  environment: 'PRODUCTION' | 'STAGING';
  criticality: 'CRITICAL' | 'HIGH' | 'MEDIUM';
  internetExposed: boolean;
  status: 'SECURE' | 'REVIEW_NEEDED';
}

export interface SecurityVulnerability {
  id: string;
  cve?: string;
  title: string;
  severity: 'CRITICAL' | 'HIGH' | 'MEDIUM' | 'LOW';
  asset: string;
  status: 'OPEN' | 'IN_PROGRESS' | 'MITIGATED' | 'VERIFIED';
  cvss: number;
}

export interface SecurityAlert {
  id: string;
  timestamp: string;
  type: string;
  severity: 'CRITICAL' | 'HIGH' | 'MEDIUM';
  source: string;
  status: 'NEW' | 'INVESTIGATING' | 'RESOLVED';
}

export const MOCK_SECURITY_ASSETS: SecurityAsset[] = [
  {
    id: 'asset-1',
    name: 'YamooPay Next.js Web App',
    type: 'APPLICATION',
    environment: 'PRODUCTION',
    criticality: 'CRITICAL',
    internetExposed: true,
    status: 'SECURE',
  },
  {
    id: 'asset-2',
    name: 'PostgreSQL Primary Database',
    type: 'DATABASE',
    environment: 'PRODUCTION',
    criticality: 'CRITICAL',
    internetExposed: false,
    status: 'SECURE',
  },
  {
    id: 'asset-3',
    name: 'AI Gateway & Tool Router',
    type: 'API',
    environment: 'PRODUCTION',
    criticality: 'HIGH',
    internetExposed: true,
    status: 'SECURE',
  },
  {
    id: 'asset-4',
    name: 'Dokploy Deployment Container Runtime',
    type: 'CONTAINER',
    environment: 'PRODUCTION',
    criticality: 'CRITICAL',
    internetExposed: false,
    status: 'SECURE',
  },
];

export const MOCK_VULNERABILITIES: SecurityVulnerability[] = [
  {
    id: 'VULN-2026-001',
    cve: 'CVE-2026-3821',
    title: 'Transitive npm package dependency advisory in build toolchain',
    severity: 'MEDIUM',
    asset: 'YamooPay Next.js Web App',
    status: 'IN_PROGRESS',
    cvss: 5.4,
  },
];

export const MOCK_SECURITY_ALERTS: SecurityAlert[] = [
  {
    id: 'ALT-901',
    timestamp: new Date(Date.now() - 1000 * 60 * 25).toISOString(),
    type: 'RATE_LIMIT_EXCEEDED_API',
    severity: 'MEDIUM',
    source: 'API Gateway / RateLimiter',
    status: 'RESOLVED',
  },
  {
    id: 'ALT-902',
    timestamp: new Date(Date.now() - 1000 * 60 * 110).toISOString(),
    type: 'ADMIN_STEP_UP_MFA_SUCCESS',
    severity: 'MEDIUM',
    source: 'Identity Defense Layer',
    status: 'RESOLVED',
  },
];
